import styles from './ToolTipBox.module.scss';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';

export function ToolTipBox() {

  const { t } = useTranslation();

  return (
   <div className={cx(styles.toolTipBox)} data-testid="toolTipBox" aria-label="toolTipDescription">
    {t('checkoutPage.checkoutGiftCard.toolTip')}
   </div>
  );
}
